class CartDiscount extends HTMLElement {
  connectedCallback() {
    this.querySelector('form').addEventListener('submit', this.submit.bind(this));
  }

  async submit(event) {
    event.preventDefault();
    if (this.pending) return;
    const input = this.querySelector('input');
    const error = this.querySelector('[role="alert"]');
    const remove = event.submitter?.hasAttribute('data-remove');
    const code = input.value.trim();
    error.textContent = '';
    error.hidden = true;
    if (!remove && !code) {
      error.textContent = 'Enter a discount code.';
      error.hidden = false;
      input.focus();
      return;
    }
    this.pending = true;
    const controls = this.querySelectorAll('input, button');
    controls.forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!response.ok) throw new Error();
      const current = await response.json();
      const codes = (current.discount_codes || []).filter((item) => item.applicable).map((item) => item.code);
      const drawer = this.closest('cart-drawer');
      const body = { discount: remove ? '' : [...new Set([...codes, code])].join(',') };
      if (drawer) {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }
      const updated = await fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!updated.ok) throw new Error();
      const cart = await updated.json();
      if (!remove && !cart.discount_codes?.some((item) => item.applicable && item.code.toLowerCase() === code.toLowerCase())) {
        error.textContent = 'This discount code cannot be applied to your cart.';
        error.hidden = false;
        return;
      }
      if (drawer && cart.sections?.['cart-drawer'] && cart.sections?.['cart-icon-bubble']) {
        drawer.renderContents(cart);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cartData: cart });
      } else {
        window.location.reload();
      }
    } catch (err) {
      error.textContent = 'Unable to update the discount. Please try again.';
      error.hidden = false;
    } finally {
      this.pending = false;
      controls.forEach((control) => { control.disabled = false; });
    }
  }
}

if (!customElements.get('cart-discount')) customElements.define('cart-discount', CartDiscount);
